import React from "react";
import Slider from "react-slick";
import { getMediaUrl } from "../../utils/media";

import "../../../node_modules/slick-carousel/slick/slick.css";
import "../../../node_modules/slick-carousel/slick/slick-theme.css";

const compareAwards = (a, b) => {
  const aMenuOrder = Number.isFinite(a.menuOrder) ? a.menuOrder : 0;
  const bMenuOrder = Number.isFinite(b.menuOrder) ? b.menuOrder : 0;

  if (aMenuOrder !== bMenuOrder) {
    return aMenuOrder - bMenuOrder;
  }

  const aDate = a.date ? new Date(a.date).getTime() : 0;
  const bDate = b.date ? new Date(b.date).getTime() : 0;

  if (aDate !== bDate) {
    return aDate - bDate;
  }

  return String(a.id).localeCompare(String(b.id));
};

const AwardCats = ({ awardCat, awardCatTitle }) => {
  const awards =
    awardCat && awardCat[0] && awardCat[0].awards && awardCat[0].awards.nodes
      ? [...awardCat[0].awards.nodes].sort(compareAwards)
      : [];

  const slideCount = Math.max(1, Math.min(3, awards.length));
  const slickSettings = {
    dots: true,
    infinite: awards.length > 1,
    speed: 500,
    slidesToShow: slideCount,
    slidesToScroll: slideCount,
    centerMode: false,
    variableWidth: false,
    arrows: false,
    lazyLoad: "ondemand",
    responsive: [
      {
        breakpoint: 980,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: awards.length > 1
        }
      }
    ]
  };

  return (
    <section className="content award-block">
      <div className="content-block clearfix">
        <div className="eighty-spacer"></div>
        <div className="centered-content-container">
          <div className="centered-title-holder">
            <span>
              {awardCatTitle ? awardCatTitle : "Proud of our Achievements"}
            </span>
          </div>
        </div>

        {awards.length ? (
          <div className="award-slick-container">
            <Slider {...slickSettings}>
              {awards.map((prod, index) => (
                <div key={prod.id || index}>
                  <div className="award-img-container">
                    <img
                      src={getMediaUrl(prod.featuredImage)}
                      alt={prod.featuredImage.altText}
                      title={prod.featuredImage.title}
                    ></img>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        ) : null}
      </div>
      <div className="eighty-spacer"></div>
    </section>
  );
};

export default AwardCats;
